import { GetListResult } from "react-admin";
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters";
import HttpClient from "../HttpClient";

export default class AppConstantService {
    async fetchAllAppConstants(
        limit: number,
        offset: number,
        filters: any,
        sort: {}
      ): Promise<GetListResult<any>> {
        filters = ConstructSequelizeFilters(filters, ["name","value"],[],[],[],[]);
        let data = await HttpClient.get("/app-constant/all", {
          params: {
            limit,
            offset,
            filters,
            sort,
          },
        });
        return {
          data: !!data && !!data?.data ? data?.data?.data : [],
          total: !!data && !!data?.data ? data?.data?.count : 0,
        };
    }

    async fetchAppConstantById(id: number): Promise<any> {
        const data = await HttpClient.get(`/app-constant/${id}`);
        return data;
    }

    // Value of a single constant, or null when it is not seeded. Uses /names (not /name/:name)
    // because it answers with an empty list instead of erroring on a missing constant.
    async fetchAppConstantValueByName(name: string): Promise<string | null> {
        const data = await HttpClient.get("/app-constant/names", { params: { names: [name] } });
        const match = (data?.data ?? []).find((appConstant: any) => appConstant?.name === name);
        return match?.value ?? null;
    }

    async createAppConstant(payload: any): Promise<any> {
        const data = await HttpClient.post("/app-constant", payload);
        return data?.data;
    }

    async updateAppConstant(id: number, payload: any): Promise<any> {
        const data = await HttpClient.patch(`/app-constant/${id}`, payload);
        return data?.data;
    }

}